namespace $.$$ {
	$mol_style_define( $shm_hitalama_components, {
		List: { width: '19rem', flex: { basis: '19rem', grow: 0, shrink: 0 } },
		Row: { flexDirection: 'column', alignItems: 'stretch', minWidth: 0, width: '100%' },
		Row_name: { minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' },
		Row_fqn: { font: { size: '.75rem' }, color: $mol_theme.shade, overflowWrap: 'anywhere' },
		Group_row: { minWidth: 0, width: '100%' },
		Group: { minWidth: 0, width: '100%' },
		Group_title: { minWidth: 0, width: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' },
	})
}
